// !FIXME - Easy - Flow type this file
import React from 'react'
import { Link } from '../../../../../../shared/components/Link'
import { Dimmer, Loader } from 'semantic-ui-react'

import { SCHOOL_FINDER } from 'constants/urls'
import { platinum, silver } from 'constants/inlineStyles'

import FlyerCardList from './components/FlyerCardList'
import ErrorMessage from './components/ErrorMessage'
import DistrictDisclaimer from './components/DistrictDisclaimer'

let styles = {}

const FlyerGrid = ({
  flyers,
  resource,
  resourceId,
  districtError,
  schoolError,
  lastUpdated,
  currentCategory,
  setCategoryFilter,
  districtId,
  handleMetricClick,
  disclaimer
}) => {
  let errorMessage = null
  let errorEnabled = false

  // !FIXME - Easy - Move each of these error messages into their own component
  if (districtError) {
    errorEnabled = true
    errorMessage = (
      <ErrorMessage
        icon={'university'}
        header={'Hmmm, we’re not sure which district to show you.'}
        content={
          <span>
            Please use our&nbsp;
            <a href={SCHOOL_FINDER} target="_blank" key="noDistrictFound">
              school finder
            </a>
            &nbsp;to select a school district of interest.
          </span>
        }
      />
    )
  } else if (schoolError) {
    errorEnabled = true
    errorMessage = (
      <ErrorMessage
        icon={'university'}
        header={'Hmmm, we’re not sure which school to show you.'}
        content={
          <span>
            Please use our &nbsp;
            <a href={SCHOOL_FINDER} target="_blank" key="noSchoolFound">
              school finder
            </a>
            &nbsp;to select a school of interest.
          </span>
        }
      />
    )
  } else if (
    flyers.length === 0 &&
    lastUpdated > 0 &&
    currentCategory === 'All'
  ) {
    errorEnabled = true
    errorMessage = (
      <ErrorMessage
        icon={'file outline'}
        header={`Unfortunately, there are no flyers for this ${
          resource === 'districts' ? 'district' : 'school'
        } at the moment.`}
        content={'Please check the district for current flyers.'}
      />
    )
  } else if (
    flyers.length === 0 &&
    lastUpdated > 0 &&
    currentCategory !== 'All'
  ) {
    errorEnabled = true
    errorMessage = (
      <ErrorMessage
        icon={'file outline'}
        header={`Unfortunately, there are no flyers for this ${
          resource === 'districts' ? 'district' : 'school'
        } at the moment.`}
        content={
          <span>
            Please check this category for the whole&nbsp;
            <Link to={`/flyers/all/districts/${districtId}`}>
              district
            </Link>&nbsp;or&nbsp;
            <span
              role="option"
              tabIndex="0"
              aria-selected="false"
              aria-checked="false"
              onKeyUp={() => setCategoryFilter('All')}
              onClick={() => setCategoryFilter('All')}
              className="span--link" // Move inline styles to class?
              style={styles.spanLink}
            >
              all
            </span>
            &nbsp;categories for this school.
          </span>
        }
      />
    )
  } else if (flyers.length === 0) {
    errorEnabled = true
    errorMessage = (
      <Dimmer active>
        <Loader />
      </Dimmer>
    )
  }

  // We have special hard coded logic for district 7134 and 5207 to render an
  // extra disclaimer up top.
  const shouldRenderTopDisclaimer = (districtId === '7134' || districtId === '5207') && !errorEnabled

  return (
    <div style={styles.flyerGridWrapper}>
      {shouldRenderTopDisclaimer ? <DistrictDisclaimer disclaimer={disclaimer} /> : <div />}
      {errorMessage || (
        <FlyerCardList
          handleMetricClick={handleMetricClick}
          flyers={flyers}
          resource={resource}
          resourceId={resourceId}
        />
      )}
      {!errorEnabled ? <DistrictDisclaimer disclaimer={disclaimer} /> : <div />}
    </div>
  )
}

styles = {
  flyerGridWrapper: {
    backgroundColor: platinum,
    border: `1px solid ${silver}`,
    flex: '0 1 auto',
    position: 'relative',
    display: 'flex',
    flexFlow: 'column nowrap',
    justifyContent: 'space-between'
  },
  spanLink: { color: '#4183C4', cursor: 'pointer' }
}

export default FlyerGrid



// WEBPACK FOOTER //
// ./src/screens/Flyers/screens/FlyerGrid/components/FlyerGridBody/index.js